export const locales = ["en", "zh-CN", "zh-HK"] as const;

export type Locale = (typeof locales)[number];

export const defaultLocale: Locale = "en";

/** Short labels for the header segmented control. */
export const localeShortLabels: Record<Locale, string> = {
  en: "EN",
  "zh-CN": "简",
  "zh-HK": "繁",
};

/** Full names for aria-labels / footer. */
export const localeFullLabels: Record<Locale, string> = {
  en: "English",
  "zh-CN": "简体中文",
  "zh-HK": "繁體中文",
};

export function isLocale(value: string): value is Locale {
  return (locales as readonly string[]).includes(value);
}
